var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.584 189.321C218.835 175.108 234.635 167.712 249.553 172.015L314.496 190.749C322.788 193.141 329.707 198.88 333.589 206.586L360.5 260L436.542 370.564C440.097 375.733 442 381.858 442 388.131V391C442 408.121 428.121 422 411 422H88.4971C71.654 422 58 408.346 58 391.503C58 383.196 61.3885 375.249 67.3824 369.497L177.062 264.258C179.992 261.447 182.341 258.087 183.976 254.37L212.584 189.321Z",
    fill: "#231942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.003 470C265.563 469.984 280.782 465.437 293.799 456.912C306.816 448.388 317.069 436.256 323.303 422H176.703C182.938 436.256 193.19 448.388 206.207 456.912C219.225 465.437 234.443 469.984 250.003 470Z",
    fill: "#f0fff1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M394 278V217.47C394 147 366.64 85.6096 298 69.9996C298 69.9996 301.719 36.9599 290 21.9996C270.735 -2.59492 229.266 -2.59492 210 21.9996C198.281 36.9599 202 69.9996 202 69.9996C133.12 85.6096 106 146.76 106 217.47V278C106 278 65.3844 311.643 58.0003 342C53.5699 360.214 58.0003 390 58.0003 390H442C442 390 446.431 360.214 442 342C434.616 311.643 394 278 394 278Z",
    fill: "#f0fff1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.d48da43708925340fd92d9b3d2593f8f.svg";
export { ForwardRef as ReactComponent };